import { Button, ImageListItem, Typography } from '@mui/material';

import calendar from '../../assets/icons/calendar.svg';
import { useSelector } from 'react-redux';

const styledCalandarIcon = {
  display: 'inline-block',
  width: 80,
  height: 60,
  position: 'relative',
  mt: 2,
};

const styledDayNumber = {
  position: 'absolute',
  color: '#52418a',
  fontWeight: '600',
  top: '50%',
  left: '51%',
  transform: 'translate(-50%, -50%)',
};

const JoiningDetails = (props) => {
  const months = [
    '',
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];
  const { candidateStatus } = useSelector((state) => state?.candidateState);
  const [joiningDay, joiningMonth, joiningYear] =
    candidateStatus && candidateStatus?.joining_date?.split('-');

  return (
    <>
      <Typography variant='body2'>
        We have got acceptance of your offer.
      </Typography>
      <Typography variant='body2'>
        {`Your date of joining as  ${candidateStatus?.designation} is`}
      </Typography>
      {joiningDay ? (
        <div style={{ position: 'relative' }}>
          <ImageListItem component='div' sx={styledCalandarIcon}>
            <img alt='Calendar' src={calendar}></img>
          </ImageListItem>
          <Typography variant='h5' sx={styledDayNumber}>
            {joiningDay}
          </Typography>
          <Typography fontSize='1rem' color='primary'>
            {`${months[parseInt(joiningMonth)]} ${joiningYear}`}
          </Typography>
        </div>
      ) : (
        <Typography variant='body2' sx={{ my: 2 }}>
          {`We will inform your joining date shortly`}
        </Typography>
      )}

      {/* <Typography variant='body2' sx={{ my: 2 }}>
                Please confirm your joining before
                <b>{'-'}</b> and upload further required documents.
            </Typography> */}
      {/* <Button
        sx={{ m: 1, mt: '1.5rem' }}
        variant='contained'
        onClick={() => props?.onAccept()}>
        Confirm Joining
      </Button> */}
      {/* <Button sx={{ m: 1,mt:'1.5rem' }} variant='outlined' onClick={() => props?.onRequest()}>
                Request New Joining Date
            </Button> */}
      <Button
        sx={{ m: 1, mt: '1.5rem' }}
        variant='outlined'
        onClick={() => props?.onReject()}>
        Reject Offer
      </Button>
    </>
  );
};

export default JoiningDetails;
